import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function Project( { lang }) {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    fetch(`/api/admin/projects/project.php?id=${id}`)
      .then(res => res.json())
      .then(data => {
        setProject(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Erreur chargement projet", err);
        setLoading(false);
      });

  }, [id]);

  if (loading) {
    return (
      <section className="py-5 text-center">
        <p>Chargement du projet…</p>
      </section>
    );
  }

  if (!project) return null;

  return (
    <section id="project">
      <div className="container text-center">
        <div className='page-header'>
            <NavLink to="/projects"><ArrowLeft size={40} className='back-arrow' /></NavLink>
            <h1 className="page-title" 
            style={{
              maxWidth: '250px'}}
            >{project.title.toUpperCase()}</h1>
        </div>
        <div className="container" style={{maxWidth:'800px', marginBottom:'3rem'}}>
            <h5 className="mb-4" style={{fontFamily: "pangram-eiko-lightItalic"}}>
              {lang === "fr" ? project.desc : project.desc_en}
            </h5>
            {project.image && (
              <div className="mt-5">
                <img
                  src={project.image_1}
                  alt={project.title}
                  className="img-fluid w-100"
                  style={{ objectFit: "contain" }}
                />
              </div>
            )}
            {(project.image_2 || project.image_3) && (
              <div className="row mt-4">

                {project.image_2 && (
                  <div className="col-12 col-md-6 mb-2">
                    <img
                      src={project.image_2}
                      alt={project.title}
                      className="img-fluid w-100"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                )}

                {project.image_3 && (
                  <div className="col-12 col-md-6 mb-2">
                    <img
                      src={project.image_3}
                      alt={project.title}
                      className="img-fluid w-100"
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                )}

              </div>
            )}
            {project.credits && (
                  <figcaption className="photo-credit">
                    @ {project.credits}
                  </figcaption>
            )}
            <p className="mb-4 mt-4" style={{ textAlign:"justify"}}>{lang === "fr" ? project.text : project.text_en}</p>
            {(project.link || project.link_2) && (() => {

              const videos = [project.link, project.link_2].filter(Boolean);
              const isSingle = videos.length === 1;

              return (
                <div className="row mt-4 g-4">
                  {videos.map((video, index) => (
                    <div
                      key={index}
                      className={isSingle ? "col-12" : "col-12 col-md-6"}
                    >
                      <div className="ratio ratio-16x9 overflow-hidden">
                        <iframe
                          src={video.replace("watch?v=", "embed/")}
                          allowFullScreen
                          title={`${project.title}-${index}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              );
            })()}
        </div>
      </div>
    </section>
  );
}